import { defineStore } from 'pinia';
import { useCustomerStore } from './customer';
import GeneralHelper from '@/helpers/GeneralHelper';

export const useThemeStore = defineStore('theme', {
	state: () => ({
		themes: [],
		selected_theme: null,
		initial_loading: true,
	}),
	getters: {
		getAvailableThemes(state) {
			if (!state.customer) return;
			return state.themes;
		},
		getDefaultThemeId(state) {
			const default_theme = state.themes?.find(theme => theme.is_default === true);
			return default_theme ? default_theme.id : null;
		},
		getSelectedThemeColors(state) {
			if (!state.themes?.length) return {};

			// 1. Try to find the currently selected theme
			const selected_theme = state.themes.find(theme => theme.id === state.selected_theme);
			if (selected_theme) return selected_theme.colors;

			// 2. If not found, fall back to the default theme
			const default_theme = state.themes.find(theme => theme.is_default === true);
			if (default_theme) return default_theme.colors;

			// 3. As a last resort, return an empty object
			return {};
		},
		getThemeTitles(state) {
			return state.themes.map((theme_item) => {
				return {
					id: theme_item.id,
					name: theme_item.name
				};
			});
		},
		getSelectedThemeName(state) {
			const active_theme = state.themes.find(theme => theme.id === state.selected_theme);

			if (active_theme) return active_theme.name;

			const default_theme = state.themes.find(theme => theme.is_default === true);

			return default_theme ? default_theme.name : '';
		}
	},
	actions: {
		setThemes(data) {
			this.themes = data;
			this.findAvailableTheme();
			this.initial_loading = false;
		},
		enableTheme(theme_id) {
			this.selected_theme = theme_id;
			this.applyColorThemeVariables();
			const customerStore = useCustomerStore();

			if (customerStore.isLoggedIn && !this.initial_loading) {
				return global.axios.post(process.env.VUE_APP_API_URL + '/account/theme/update', {theme_id: this.selected_theme}).then((response) => {
					// location.reload();
					return Promise.resolve(response);
				}).catch((error) => {
					console.log(error);
					return Promise.reject(error);
				})
			}
		},
		findAvailableTheme() {
			const customerStore = useCustomerStore();

			const customer_theme_id = customerStore.getCustomer?.theme_id;

			if (customerStore.isLoggedIn && customer_theme_id) {
				this.enableTheme(customer_theme_id);
				return;
			}

			if (!this.selected_theme) this.enableTheme(this.getDefaultThemeId);
		},
		applyColorThemeVariables() {
			const enabled_theme = this.getSelectedThemeColors;

			document.documentElement.style.setProperty('--dark-gray', enabled_theme.primary_color);
			document.documentElement.style.setProperty('--primary', enabled_theme.secondary_color);
			document.documentElement.style.setProperty('--dark', GeneralHelper.darkenHex(enabled_theme.primary_color, 0.15));
			document.documentElement.style.setProperty('--light-dark', GeneralHelper.lighten(enabled_theme.primary_color, 0.12));
			document.documentElement.style.setProperty('--light-primary', GeneralHelper.shift(enabled_theme.secondary_color, 15, 0, 6));
			document.documentElement.style.setProperty('--link-hover', GeneralHelper.darkenHex(enabled_theme.secondary_color, 0.35));
			document.documentElement.style.setProperty('--green-dark', GeneralHelper.darkenHex(enabled_theme.secondary_color, 0.49));
			document.documentElement.style.setProperty('--secondary', enabled_theme.third_color);
			document.documentElement.style.setProperty('--white', enabled_theme.primary_text_color);
			document.documentElement.style.setProperty('--text-secondary-color', enabled_theme.secondary_text_color);
			document.documentElement.style.setProperty('--odd-price-up', enabled_theme.odd_price_up_color);
			document.documentElement.style.setProperty('--odd-price-down', enabled_theme.odd_price_down_color);
			// document.documentElement.style.setProperty('--odd-background-color', enabled_theme.odd_color);
			// document.documentElement.style.setProperty('--linear-gradient-primary-color', enabled_theme.linear_gradient_primary);
			// document.documentElement.style.setProperty('--linear-gradient-secondary-color', enabled_theme.linear_gradient_secondary);
			document.documentElement.style.setProperty('--off-gray', enabled_theme.selector_background_color);
			document.documentElement.style.setProperty('--buttons-text-color', enabled_theme.buttons_text_color);

			// Don't forget to handle the loading state if needed
			this.initial_loading = false;
		},
	},
	persist: {
		storage: localStorage,
		paths: ['selected_theme'],
	},
})